import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface Props {
    to: string;
    text: string;
    pullRight?: boolean;
    marginTop?: string;
    className?: string;
}

function LinkButton(props: Readonly<Props>) {
    let className = 'btn btn-primary';
    if (props.pullRight) {
        className += ' pull-right';
    }
    if (props.className) {
        className += ' ' + props.className;
    }
    const style = {
        marginBottom: '1em',
        marginTop: props.marginTop,
    };

    return (
        <Link to={props.to} style={{ color: 'white' }}>
            <Button
                className={className}
                type="button"
                style={style}
                data-testid={props['data-testid']}
            >
                {'\t' + props.text}
            </Button>
        </Link>
    );
}

export default LinkButton;
